export const MENU_KEYS = {
  LOCATION: "/location",
  USER: "/user",
  COMPANY: "/company",
  RELEASE_NOTES: "/release-notes",
};
